const dotenv = require('dotenv')

// require and configure dotenv, will load vars in .env in PROCESS.ENVv
if (process.env.STAGE !== 'production') {
  dotenv.config()
}

const config = {
  staging: {},
  production: {
    LOG_ROCKET_KEY: 'ybycvo/jaxxon-production',
    CONTENTFUL_HOST: 'cdn.contentful.com',
  },
  trustPilotConfig: {
    apiKey: process.env.GATSBY_TRUSTPILOT_API_KEY,
    domainName: 'jaxxon.com', // ex: trustpilot.com
  },
  CONTENTFUL_HOST: 'preview.contentful.com',
  STAGE: process.env.GATSBY_STAGE,
  LOG_ROCKET_KEY: 'ybycvo/jaxxon-staging',
  SPACE_ID: process.env.SPACE_ID,
  ACCESS_TOKEN: process.env.ACCESS_TOKEN,
  GATSBY_STOREFRONT_URL: 'https://checkout.jaxxon.com/api/2020-07/graphql.json',
  GATSBY_SHOPIFY_ACCESS_TOKEN: process.env.GATSBY_SHOPIFY_ACCESS_TOKEN,
  GATSBY_SHOPIFY_SHOP_NAME: process.env.GATSBY_SHOPIFY_SHOP_NAME,
  GATSBY_PIXEL_ID: process.env.GATSBY_PIXEL_ID,
  GATSBY_SNAPCHAT_PIXEL_ID: process.env.GATSBY_SNAPCHAT_PIXEL_ID,
  GATSBY_GOOGLE_ANALYTICS: process.env.GATSBY_GOOGLE_ANALYTICS,
  GATSBY_GOOGLE_TAG_MGR: process.env.GATSBY_GOOGLE_TAG_MGR,
  SPREADSHEET_ID: process.env.SPREADSHEET_ID,
  GATSBY_BUGSNAG_KEY: process.env.GATSBY_BUGSNAG_KEY || '',
  REACH_MERCH_ID: '9b4d4156-27a6-4e5e-9627-75bff48fd33b',
  GATSBY_LOOP_CART_KEY: process.env.GATSBY_LOOP_CART_KEY,
  GATSBY_TRUSTPILOT_API_KEY: process.env.GATSBY_TRUSTPILOT_API_KEY,
  GATSBY_REBUY_API_KEY: process.env.GATSBY_REBUY_API_KEY,
  GOOGLE_SHEETS_CONFIG:
    process.env.GOOGLE_SHEETS_CONFIG &&
    JSON.parse(process.env.GOOGLE_SHEETS_CONFIG),
  GATSBY_ATTENTIVE_TOKEN: process.env.GATSBY_ATTENTIVE_TOKEN,
}

const flattenedConfig = {
  ...config,
  ...config[process.env.GATSBY_STAGE],
}

module.exports.config = flattenedConfig
module.exports.getEnvVars = () => flattenedConfig
